import {
  latitudeValidation,
  postalAddressValidation,
} from '../../../../../helper/FeildValidations';
import InputField from '../../../../common/InputField';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector} from 'react-redux';
import Map from '../../../../common/Map';
import { GO0GLE_API_KEY } from '../../../../../settings';
import SelectOption from '../../../../common/SelectOption';
import {getMRTLocationData} from '../../SpaceAction';
import { emptyValidation} from "../../../../../helper/FeildValidations";

const SpaceLocation = ({ form }) => {
  const location = form.getFieldValue('location');
  const mrtStatus = form.getFieldValue('nearMrtAvailability');
  const [data, setData] = useState([
    {
      latitude: null,
      longitude: null,
    },
  ]);
  const dispatch = useDispatch();
  const mrtLocations = useSelector(state => state.space?.mrtLocations?.data?.locations || []);

  useEffect(() => {
    setData([
      {
        latitude: location?.geoLocation?.latitude ? location.geoLocation?.latitude : null,
        longitude: location?.geoLocation?.longitude ? location.geoLocation?.longitude : null,
      },
    ]);
  }, [location]);

  const setMarcer = (coord) => {
    const { latLng } = coord;
    setData([{ longitude: latLng.lng(), latitude: latLng.lat() }]);
    form.setFieldsValue({
      location: { ...location, geoLocation: { longitude: latLng.lng(), latitude: latLng.lat() } },
    });
  };

  useEffect(()=>{
    dispatch(getMRTLocationData());
  },[])

  const selectOptions = [
    {key:"1",name:"Yes",value: true},
    {key:"2",name:"No",value: false}
  ];

  return (
    <div className="basic-details-wrapper">
      <h3>Space Location</h3>
      <InputField
        name={['location', 'geoLocation', 'latitude']}
        label={'Latitude'}
        rules={latitudeValidation}
        isDisabled={false}
        handleOnChange={(e) => setData((prevVal) => [{ ...prevVal, latitude: e.target.value }])}
      />
      <InputField
        name={['location', 'geoLocation', 'longitude']}
        label={'Longitude'}
        rules={latitudeValidation}
        isDisabled={false}
        handleOnChange={(e) => setData((prevVal) => [{ ...prevVal, longitude: e.target.value }])}
      />

      {(location?.country==="SG")?
       <SelectOption
       isMultiple={false}
       name={['nearMrtAvailability']}
       placeholder={'MRT Status'}
       label={'MRT Status'}
       values={selectOptions}
       labelName={'name'}
       valueName={'value'}
       rules={emptyValidation}
       handleOnSelect={(e) => setData((prevVal) => [{...prevVal, nearMrtAvailability: e}])}
     />
      :
      (location?.country==="LK")?
      <SelectOption
      isMultiple={false}
      name={['parkingAvailability']}
      placeholder={'Parking Availability'}
      label={'Parking Availability'}
      values={selectOptions}
      labelName={'name'}
      valueName={'value'}
      rules={emptyValidation}
      handleOnSelect={(e) => setData((prevVal) => [{...prevVal, parkingAvailability: e}])}
    />
    :<></>}

    {(location?.country==="SG" && mrtStatus)?
      <SelectOption
        isMultiple={true}
        name={['nearByLocations']}
        placeholder={'MRT Locations'}
        label={'MRT Locations'}
        values={mrtLocations}
        rules={[{required:mrtStatus}]}
        handleOnSelect={(e) => setData((prevVal) => [{ ...prevVal, nearByLocations: e}])}
      />
      :<></>}

      <div className="map-wrapper">
        <Map
          center={{ lat: Number(data?.[0]?.latitude) || 7.8731, lng: Number(data?.[0]?.longitude) || 80.7718 }}
          zoom={8}
          marker={false}
          places={data}
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GO0GLE_API_KEY}`}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: '96vh' }} />}
          mapElement={<div style={{ height: `100%` }} />}
          onClick={setMarcer}
        />
      </div>
      <br />
      <br />
    </div>
  );
};

export default SpaceLocation;
